module.exports = __webpack_public_path__ + "img/certificate-en-mobile.410c4867.jpg";